import { Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import RowShorttag from './RowShorttag.vue';

export default Node.create({
  name: 'RowShorttag',
  group: 'block',
  content: 'ColShorttag+',
  defining: true,
  isolating: true,
  marks: '_',
  allowGapCursor: true,
  parseHTML() {
    return [
      {
        tag: 'row-shorttag',
      },
    ];
  },
  renderHTML() {
    return ['div', { class: 'row' }, 0];
  },
  addNodeView() {
    return VueNodeViewRenderer(RowShorttag);
  },
});
